// extracted by mini-css-extract-plugin
module.exports = {"container":"BotOverall_container__W-wif"};